import { createContext, useContext, useState } from "react";
import useSWR from "swr";
import { fetchData } from "../../lib/dashboard/data";


const SubscriptionContext = createContext();

const SubscriptionProvider = ({ children }) => {

    const [selectedPlan, setSelectedPlan] = useState(null);

    //fetch all pricing plans
    const
        {
            data: plansData,
            isLoading: isPlansLoading
        }
            = useSWR("/account/pricing", fetchData, {
                revalidateOnFocus: false,
            })

    return (
        <SubscriptionContext.Provider value={{
            plansData,
            isPlansLoading,
            selectedPlan,
            setSelectedPlan,
        }}>
            {children}
        </SubscriptionContext.Provider>
    );
};

export default SubscriptionProvider;

export const useSubscriptionContext = () => {
    return useContext(SubscriptionContext);
}